import * as dis2 from '../dispossitions/dispossitions.const';
import {OTHER_FEE} from './payamnets.const';

export const ACTIVITY_TYPE_TRAINING = 'Training';
export const ACTIVITY_TYPE_CONFLICT_RESOLUTION = 'Conflict Resolution';
export const ACTIVITY_TYPE_OUTREACH = 'Outreach';
export const ACTIVITY_TYPE_CMC_EVENTS = 'CMC Events';
export const ACTIVITY_TYPE_ORGANIZATIONAL_NETWORKING = 'Networking';
export const ACTIVITY_TYPE_CMC_DEVOLOPMENT = 'CMC Development';

export const ACTIVITY_TYPE_CONFLICT_RESOLUTION_ID = '65f062bc2d71dfb4e188033e';
export const ACTIVITY_TYPE_TRAINING_ID = '65f062bc2d71dfb4e188034e';
export const ACTIVITY_TYPE_OUTREACH_ID = '65f062bc2d71dfb8e189014e';
export const ACTIVITY_TYPE_VOLUNTEER_STAFF_MGMT_ID = '65f062bc2d71dfb4e188011f';
export const ACTIVITY_TYPE_ORG_EVENTS_ID = '65f062bc2d71dfb4e189120e';
export const ACTIVITY_TYPE_ORG_NETWORKING_ID = '65f062bc2d71dfb5e188117e';
export const ACTIVITY_TYPE_ORG_NETWORKING_OTHER_ID = '65f063bc2d71dfb4e188118e';
export const ACTIVITY_TYPE_ORG_DEV_ID = '65f062bc2d71dfb4e188014e';
export const ACTIVITY_TYPE_OTHER_ID = '65f062bc2d71dfb4e188122e';

export const ACTIVITY_SUB_TYPE_MEDIATION = '65f062bc2d71dfb4e188009e';
export const ACTIVITY_SUB_TYPE_CONCILIATION = '65f062bc2d71dfb4e188010e';
export const ACTIVITY_SUB_TYPE_RESTORATIVE_PRACTICES = '65f062bc9d71dfb4e188013e';
export const ACTIVITY_SUB_TYPE_RE_ENTRY_INFO_SESSION = '65f062bc2d71dfb4e188013e';
export const ACTIVITY_SUB_TYPE_GENERAL_OUTREACH = '65f062bc2d71dfb8e188014e';

export const CMC_DEV_OTHER = {
    _id: ACTIVITY_TYPE_ORG_NETWORKING_OTHER_ID,
    value: 'other',
    label: 'Other',
    defaultDisposition: dis2.ON_OTH_OPEN_PENDING,
    dispositions: [dis2.ON_OTH_OPEN_PENDING, dis2.ON_OTH_ATTENDED, dis2.ON_OTH_OTHER],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const ORGANIZATIONAL_NETWORKING = {
    _id: ACTIVITY_TYPE_ORG_NETWORKING_ID,
    label: ACTIVITY_TYPE_ORGANIZATIONAL_NETWORKING,
    icon: 'organizationalNetworking',
    description: 'Events organized by other entities',
    subTypes: CMC_DEV_OTHER,
};
